import { Checkbox, Heading, Paragraph } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';
import { StyledCard } from '../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';
import { VarmesystemBrukCheckboxes } from '../common/varmesystemBruk';
import { InstallertIOppvarmetRomRadio } from '../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const Fjernvarme = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const fjernvarmeSelected = watch('fjernvarme.selected');
  const oppvarmingBrukSelection = watch('fjernvarme.value');
  const hasSelectedRomoppvarming = oppvarmingBrukSelection?.bruk?.romoppvarming;

  const selectionError = formState.errors.fjernvarme?.selected;

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!selectionError}
        label={t('fjernvarme.label')}
        {...register('fjernvarme.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {fjernvarmeSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('fjernvarme.heading')}
            </Heading>
            <Paragraph>{t('fjernvarme.description')}</Paragraph>
          </LeftBorderedContent>

          <Heading level={3} data-size="2xs">
            {t('fjernvarme.oppvarmingBruk.label')}
          </Heading>
          <StyledCard isActive>
            <InstallasjonsArRadio
              name={`fjernvarme.value.varmesentral`}
              translationKeyPrefix={`form.oppvarming.fjernvarme.installasjonsAr`}
            />
            <InstallertIOppvarmetRomRadio name="fjernvarme.value.varmesentral.installertIOppvarmetRom" />

            <VarmesystemBrukCheckboxes name="fjernvarme.value.bruk" />

            {hasSelectedRomoppvarming && <Fordelingssystem />}
          </StyledCard>
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
